import React, { useState } from 'react';
import './Header.css';
import { Link } from 'react-router-dom';
import logo from '../logo.svg';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../auth/AuthContext';
import CountrySelector from './CountrySelector';

const dropdownData = {
  movie: {

    image:'/images/nowplaying.jpg',
    columns: [
      {
        title: 'Now Playing',
        links: [
          { href: '/Showtimes', label: 'All Movies' },
          { href: '/Showtimes', label: 'Showtimes Near You' },
          { href: '#giftcards', label: 'Coming Soon' },
          { href: '#giftcards', label: 'Advance Tickets' },
        ],
      },
      {
        title: 'Special Features',
        links: [
          { href: '#giftcards', label: 'IMAX' },
          { href: '#giftcards', label: 'Dolby Cinema' },
          { href: '#giftcards', label: '3D Screenings' },
          { href: '#giftcards', label: 'Private Screenings' },
        ],
      },
      {
        title: 'StarView X',
        links: [
          { href: '#rewards', label: 'Member Benefits' },
          { href: '#giftcards', label: 'Earn & Redeem Points' },
          { href: '#giftcards', label: 'Early Access to Tickets' },
          { href: '#giftcards', label: 'Exclusive Rewards' },
        ],
      },
    ],
  },
  theater: {
    image: '/images/world.webp',
    columns: [
      {
        title: 'U.S. Theaters',
        links: [
          { href: '#rewards', label: 'StarView Phoenix' },
          { href: '#giftcards', label: 'StarView Chicago' },
          { href: '#giftcards', label: 'StarView Los Angeles' },
          { href: '#giftcards', label: 'StarView New York' },
        ],
      },
      {
        title: 'Global Theaters',
        links: [
          { href: '#giftcards', label: 'StarView London' },
          { href: '#giftcards', label: 'StarView Tokyo' },
          { href: '#giftcards', label: 'StarView Sydney' },
          { href: '#giftcards', label: 'StarView Seoul' },
          { href: '#giftcards', label: 'StarView Paris' },
        ],
      },
      {
        title: 'Find a Theater',
        links: [
          { href: '/Showtimes', label: 'Browse All Countries' },
          { href: '#giftcards', label: 'StarView Private Screenings' },
          { href: '#giftcards', label: 'Group & Corporate Bookings' },
        ],
      },
    ],
  },
  food: {
    image: '/images/vr.jpg',
    columns: [
      {
        title: 'Delivery',
        links: [
          { href: '#rewards', label: 'StarView Drivers' },
          { href: '#giftcards', label: 'International Delivery' },
        ],
      },
      {
        title: 'StarView Food',
        links: [
          { href: '#rewards', label: 'USA Partnerships' },
          { href: '#giftcards', label: 'International Partnerships' },
        ],
      },
      {
        title: 'Restaurant Sign-Up',
        links: [
          { href: '#rewards', label: 'Apply to Partner' },
          { href: '#giftcards', label: 'International Restaurant Apply' },
        ],
      },
    ],
  },
 
};

const Header = () => {
  const { t } = useTranslation();
  const [openDropdown, setOpenDropdown] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { isAuthenticated, user, logout } = useAuth();

  const handleDropdown = (key) => {
    setOpenDropdown(openDropdown === key ? null : key);
  };

  const handleSidebarOpen = () => setSidebarOpen(true);
  const handleSidebarClose = () => setSidebarOpen(false);

  return (
    <header className="amc-header">
      <div className="amc-header-content">
        {/* Left: Hamburger + Search */}
        <div className="amc-header-left">
          <button className="amc-icon-btn mobile-hamburger" aria-label="Open menu" onClick={handleSidebarOpen}>
            {/* Hamburger SVG */}
            <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect y="5" width="28" height="3.5" rx="1.75" fill="#fff"/>
              <rect y="12.25" width="28" height="3.5" rx="1.75" fill="#fff"/>
              <rect y="19.5" width="28" height="3.5" rx="1.75" fill="#fff"/>
            </svg>
          </button>
          <Link to="/Showtimes" className="amc-icon-btn" aria-label="Search movies">
            {/* Magnifying Glass SVG */}
            <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="8" stroke="#fff" strokeWidth="2.5"/>
              <line x1="19.0711" y1="19.0711" x2="24" y2="24" stroke="#fff" strokeWidth="2.5" strokeLinecap="round"/>
            </svg>
          </Link>
        </div>

        {/* Center: Logo */}
        <div className="amc-header-center">
          <Link to="/" className="amc-logo-link" aria-label="Home">
            <img src={logo} alt="StarView Cinema Logo" className="amc-header-logo" />
          </Link>
        </div>
        <div className="linksnav">
          <ul className="amc-nav-link">
            <li>
              <button type="button" onClick={() => handleDropdown('movie')}>{t('nav.seeAMovie')}</button>
            </li>
            <li>
              <button type="button" onClick={() => handleDropdown('theater')}>{t('nav.findATheater')}</button>
            </li>
            <li>
              <button type="button" onClick={() => handleDropdown('food')}>{t('nav.foodAndDrinks')}</button>
            </li>

          </ul>
          {openDropdown && (
            <div className="amc-nav-link-dropdown">
              <button className="dropdown-close-btn" onClick={() => setOpenDropdown(null)} aria-label="Close dropdown">&times;</button>
              <div className="dropdown-image-wrapper">
                <img src={dropdownData[openDropdown].image} alt="dropdown visual" className="dropdown-image" />
              </div>
              <div className="dropdown-columns">
                {dropdownData[openDropdown].columns.map((col, colIdx) => (
                  <div className="dropdown-column" key={colIdx}>
                    <div className="dropdown-column-title">{col.title}</div>
                    <div className="dropdown-column-links">
                      {col.links.map((link, idx) => (
                        <a key={idx} href={link.href}>{link.label}</a>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
        {/* Right: Country, Showtimes button and profile */}
        <div className="amc-header-right">
          <CountrySelector />
          <Link to="/Showtimes" className="amc-showtimes-btn">
            <span className="amc-showtimes-shine" />
            <span className="amc-movie-icon">
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2 6.5C2 5.67157 2.67157 5 3.5 5H14.5C15.3284 5 16 5.67157 16 6.5V7C15.1716 7 14.5 7.67157 14.5 8.5C14.5 9.32843 15.1716 10 16 10V10.5C16 11.3284 15.3284 12 14.5 12H3.5C2.67157 12 2 11.3284 2 10.5V10C2.82843 10 3.5 9.32843 3.5 8.5C3.5 7.67157 2.82843 7 2 7V6.5Z" fill="currentColor"/>
                <path d="M8.5 5.5V11.5" stroke="#001220" strokeWidth="1.1" strokeDasharray="1.4 1.4" strokeLinecap="round"/>
              </svg>
            </span>
            <span className="amc-showtimes-text">{t('nav.showtimes')}</span>
          </Link>
          {isAuthenticated ? (
            <Link to="/account" className="amc-account-pill" title="My account" style={{ textDecoration: 'none' }}>
              <span className="amc-account-avatar">{(user?.username || '?').charAt(0).toUpperCase()}</span>
              <span className="amc-account-name">{user?.username || '...'}</span>
              <svg className="amc-account-signout-icon" width="15" height="15" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13 14.5V15.5C13 16.6046 12.1046 17.5 11 17.5H5C3.89543 17.5 3 16.6046 3 15.5V4.5C3 3.39543 3.89543 2.5 5 2.5H11C12.1046 2.5 13 3.39543 13 4.5V5.5" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round"/>
                <path d="M8 10H17M17 10L14 7M17 10L14 13" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </Link>
          ) : (
            <Link className="amc-signin-pill" to="/Login">
              <svg width="16" height="16" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="14" cy="10" r="6" fill="currentColor"/>
                <rect x="5" y="19" width="18" height="7" rx="3.5" fill="currentColor"/>
              </svg>
              <span>{t('nav.signIn')}</span>
            </Link>
          )}
        </div>
      </div>

      {/* Mobile Sidebar */}
      <div className={`mobile-sidebar-overlay${sidebarOpen ? ' open' : ''}`} onClick={handleSidebarClose}></div>
      <nav className={`mobile-sidebar${sidebarOpen ? ' open' : ''}`} aria-label="Mobile menu">
        <button className="mobile-sidebar-close" onClick={handleSidebarClose} aria-label="Close menu">&times;</button>
        <div className="mobile-sidebar-country">
          <CountrySelector />
        </div>
        <div className="mobile-sidebar-links">
          <Link to="/" onClick={handleSidebarClose}>{t('nav.home')}</Link>
          <Link to="/Showtimes" onClick={handleSidebarClose}>{t('nav.showtimes')}</Link>
          <a href="#food" onClick={handleSidebarClose}>{t('nav.foodAndDrinks')}</a>
          <a href="#rewards" onClick={handleSidebarClose}>{t('nav.rewards')}</a>
          <a href="#offers" onClick={handleSidebarClose}>{t('nav.offers')}</a>
          <a href="#faq" onClick={handleSidebarClose}>{t('nav.faq')}</a>
        </div>
        <div className="mobile-sidebar-actions">
          {isAuthenticated ? (
            <button onClick={() => { logout(); handleSidebarClose(); }} className="mobile-sidebar-auth-btn">
              {t('nav.signOut')}{user?.username ? ` (${user.username})` : ''}
            </button>
          ) : (
            <Link to="/Login" onClick={handleSidebarClose} className="mobile-sidebar-auth-btn">
              {t('nav.signIn')}
            </Link>
          )}
        </div>
      </nav>
    </header>
  );
};

export default Header;
